import React from "react";
import { Carousel } from "react-bootstrap";
import CustomBanner from "../../common/customBanner";
import { logEvent } from "../../../services/log";
import { Link } from "react-router-dom";

const item = [
  // {
  //   id: 1,
  //   header: "We are hiring!",
  //   content: "Digital Church Office is hiring!",
  //   link: "/hiring",
  //   redirection: "internal",
  //   bannertype: "default",
  //   img: "https://firebasestorage.googleapis.com/v0/b/mycatholicsg-prod01.appspot.com/o/cdn%2Fbanner%2Fdco%2Fdco-hiring.png?alt=media&token=bb3f97c6-22be-42ff-8432-47bfdd839fe6",
  //   interval: 1200,
  //   orgCode: "DCO",
  //   logId: "doc_job",
  // },
  // {
  //   id: 2,
  //   header: "Advent to Christmas",
  //   content: "Reflection Booklet",
  //   link: "/one",
  //   redirection: "internal",
  //   bannertype: "default",
  //   img: "https://firebasestorage.googleapis.com/v0/b/mycatholicsg-prod01.appspot.com/o/cdn%2Fbanner%2Fone%2Fadvent-to-christmas.jpg?alt=media&token=380d9d98-bad9-4120-8f1e-b807b4a1f327",
  //   interval: 3000,
  //   orgCode: "ONE",
  //   logId: "one_adv",
  // },
  // {
  //   id: 3,
  //   header: "Season of Easter",
  //   content: "Reflection Booklet",
  //   link: "/one",
  //   redirection: "internal",
  //   bannertype: "default",
  //   img: "https://firebasestorage.googleapis.com/v0/b/mycatholicsg-prod01.appspot.com/o/cdn%2Fbanner%2Fone%2FLent%20Easter%202025%20Banner%20.png?alt=media&token=d249d96d-73be-424e-bab9-e8961c505625",
  //   interval: 3000,
  //   orgCode: "ONE",
  //   logId: "one_lent_2025_banner",
  // },
  // {
  //   id: 4,
  //   header: "Sacred Spaces",
  //   content: "Sacred Spaces",
  //   link: "/sacredspaces",
  //   redirection: "internal",
  //   bannertype: "default",
  //   img: "https://firebasestorage.googleapis.com/v0/b/mycatholicsg-prod01.appspot.com/o/cdn%2Fbanner%2Fone%2FSacred%20Spaces%20Web%20Banner.png?alt=media&token=558b9312-6d5f-4c5a-bf02-5449281ca56e",
  //   interval: 3000,
  //   orgCode: "ONE",
  //   logId: "sacredspaces_banner",
  // },
  {
    id: 5,
    header: "We are hiring!",
    content: "ALPS is hiring!",
    link: "/hiring",
    redirection: "internal",
    bannertype: "default",
    img: "https://firebasestorage.googleapis.com/v0/b/mycatholicsg-prod01.appspot.com/o/cdn%2Fbanner%2Falps%2FALPS%20JOb%20Opp38x15cmWEB%20Banner%20Lt%20Blue.png?alt=media&token=9e197988-051c-495c-97a6-5a4101956aec",
    interval: 3000,
    orgCode: "ALPS",
    logId: "alps_job",
  },
];

function BannerCarousel({ source = "/" }) {
  const handleClick = (logId, orgCode) => {
    sessionStorage.setItem("previousPage", window.location.pathname); // Store previous page
    logEvent(`${logId}`, { type: orgCode });
  };

  return (
    <Carousel indicators={false} controls={false}>
      {item?.map((i) => {
        const interval = i?.interval || 2000;
        const logId = `${i?.logId}_${source}`;
        return i?.bannertype === "default" ? (
          <Carousel.Item key={i.id} interval={interval}>
            <Link onClick={() => handleClick(logId, i?.orgCode)} to={i?.link}>
              <div className="d-block pointer">
                <img
                  className="img-fluid w-100 mb-3"
                  src={i?.img}
                  alt=""
                  style={{ objectFit: "cover" }}
                />
              </div>
            </Link>
          </Carousel.Item>
        ) : (
          <Carousel.Item key={i.id} interval={interval}>
            <div className="d-block w-100">
              <CustomBanner link={i?.link} code={source} />
            </div>
          </Carousel.Item>
        );
      })}
    </Carousel>
  );
}

export default BannerCarousel;